module.exports = __webpack_public_path__ + "img/29.08374114.jpg";